/**
 * Properly stringifies exceptions caught in catch statements.
 * Specifically designed to handle stringifying errors appropriately.
 * @param {unknown} caughtException - Exception from catch block.
 * @returns {string} - Stringified version of exception.
 */
export const stringifyException = (caughtException) => {
    try {
        if (caughtException == null || caughtException == undefined) {
            return 'The caught exception is undefined or null.';
        }
        if (caughtException instanceof Error ||
            hasErrorProperty(caughtException)) {
            return errorToString(caughtException);
        }
        return (JSON.stringify(caughtException) ||
            'The caught exception is undefined or null when JSON.stringify is applied.');
    }
    catch (error) {
        return `stringifyException Error: An error occurred while attempting to stringify an exception of type ${typeof caughtException}.`;
    }
};
/**
 * Return a properly stringified error. Handles case if it is property of object.
 * @param {Error | WithError} exception
 * @returns {string} - stringified version of exception
 */
const errorToString = (exception) => {
    if (exception instanceof Error) {
        return JSON.stringify(exception, Object.getOwnPropertyNames(exception));
    }
    const exceptionWithStringifiedErrorProperty = Object.assign(Object.assign({}, exception), { error: JSON.stringify(exception.error, Object.getOwnPropertyNames(exception.error)) });
    return JSON.stringify(exceptionWithStringifiedErrorProperty);
};
/**
 * Check if there is a property of type Error in some unknown object.
 * @param {unknown} maybeObj - unknown object
 * @returns {boolean} - boolean whether object contains error property with type Error
 */
const hasErrorProperty = (maybeObj) => {
    return ((maybeObj === null || maybeObj === void 0 ? void 0 : maybeObj.error) !== undefined &&
        maybeObj.error instanceof Error);
};
//# sourceMappingURL=StringifyException.js.map